module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDc2OCI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiM2NjY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5ib3gtdW5jaGVja2VkPC90aXRsZT48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02NzcsMTg2VjYzNEgyMjguOTJWMTg2SDY3N201MC01MEgxNzguOTJWNjg0SDcyN1YxMzZaIi8+PC9zdmc+"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/box-unchecked.svg
 ** module id = 1281
 ** module chunks = 0
 **/